module.exports = __webpack_public_path__ + "img/odp.8f4f7ad6.svg";